import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('simple-notes', { params, ...config }),
  nextFolio: (params = {}, config = {}) => axios.get('simple-notes/next-folio', { params, ...config }),
  show: (id, params = {}, config = {}) => axios.get(`simple-notes/${id}`, { params, ...config }),
  downloadPdf: (id, params = {}, config = {}) => axios.get(`simple-notes/${id}/pdf`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  previewPdf: (payload = {}, config = {}) => axios.post('simple-notes/preview-pdf', payload, {
    responseType: 'blob',
    ...config,
  }),
  exportColumns: (config = {}) => axios.get('simple-notes/exports/columns', config),
  exportFormats: (config = {}) => axios.get('simple-notes/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('simple-notes/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`simple-notes/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`simple-notes/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('simple-notes/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  activity: (id, params = {}, config = {}) => axios.get(`simple-notes/${id}/activity`, { params, ...config }),
  activityStore: (id, payload = {}, config = {}) => axios.post(`simple-notes/${id}/activity`, payload, config),
  shippingIndex: (id, params = {}, config = {}) => axios.get(`simple-notes/${id}/shipping`, { params, ...config }),
  shippingStore: (id, payload = {}, config = {}) => axios.post(`simple-notes/${id}/shipping`, payload, config),
  shippingUpdate: (id, shippingId, payload = {}, config = {}) => axios.put(`simple-notes/${id}/shipping/${shippingId}`, payload, config),
  documentsIndex: (id, params = {}, config = {}) => axios.get(`simple-notes/${id}/documents`, { params, ...config }),
  documentsStore: (id, payload = {}, config = {}) => axios.post(`simple-notes/${id}/documents`, payload, config),
  documentsUpdate: (id, documentId, payload = {}, config = {}) => axios.put(`simple-notes/${id}/documents/${documentId}`, payload, config),
  documentsDelete: (id, documentId, config = {}) => axios.delete(`simple-notes/${id}/documents/${documentId}`, config),
  documentsDownload: (id, documentId, params = {}, config = {}) => axios.get(
    `simple-notes/${id}/documents/${documentId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  documentsDownloadAll: (id, params = {}, config = {}) => axios.get(
    `simple-notes/${id}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  cancel: (id, payload = {}, config = {}) => axios.post(`simple-notes/${id}/cancel`, payload, config),
  sendSimpleNote: (id, payload = {}, config = {}) => axios.post(`send/simple-notes/${id}`, payload, config),
  downloadRequestsLatest: (params = {}, config = {}) => axios.get('simple-notes/download-requests/latest', { params, ...config }),
  downloadRequestsShow: (requestId, params = {}, config = {}) => axios.get(`simple-notes/download-requests/${requestId}`, { params, ...config }),
  downloadRequestsStore: (payload = {}, config = {}) => axios.post('simple-notes/download-requests', payload, config),
  downloadRequestsDirectDownload: (payload = {}, config = {}) => axios.post(
    'simple-notes/download-requests/direct-download',
    payload,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  downloadRequestsRetryPackage: (requestId, packageId, payload = {}, config = {}) => axios.post(
    `simple-notes/download-requests/${requestId}/packages/${packageId}/retry`,
    payload,
    config,
  ),
  downloadRequestsRegenerate: (requestId, payload = {}, config = {}) => axios.post(
    `simple-notes/download-requests/${requestId}/regenerate`,
    payload,
    config,
  ),
  downloadRequestsDownloadPackage: (requestId, packageId, params = {}, config = {}) => axios.get(
    `simple-notes/download-requests/${requestId}/packages/${packageId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  store: (payload = {}, config = {}) => axios.post('simple-notes', payload, config),
};
